import { Link } from 'react-router-dom';
import { hotManga, newManga } from '@/mocks/manga';

export default function HeroSection() {
  const topManga = hotManga.slice(0, 5);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden" aria-label="首页推荐">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20cozy%20manga%20reading%20atmosphere%20with%20warm%20ambient%20lighting%20in%20soft%20orange%20and%20cream%20tones%2C%20an%20open%20manga%20book%20with%20blank%20speech%20bubbles%20floating%20gently%20in%20the%20air%2C%20cherry%20blossom%20petals%20scattered%20across%20the%20scene%2C%20minimalist%20Japanese%20aesthetic%20with%20clean%20composition%20and%20ample%20negative%20space%2C%20abstract%20geometric%20shapes%20subtly%20layered%20in%20the%20background%2C%20warm%20gradient%20transitioning%20from%20cream%20white%20to%20soft%20coral%20peach%2C%20editorial%20design%20quality%20with%20soft%20focus%20and%20dreamy%20bokeh%20effect%2C%20no%20visible%20text%20or%20characters%2C%20atmospheric%20and%20serene%20mood%20perfect%20for%20a%20manga%20reading%20platform%20hero%20section&width=1600&height=800&seq=hero-bg-kumanwu&orientation=landscape"
        alt="酷漫屋 - 免费漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-white text-center mb-4 leading-tight">
          海量<strong className="text-primary-300">免费漫画</strong>，畅快阅读
        </h1>
        <p className="text-sm md:text-base text-white/80 text-center max-w-xl mb-8">
          日漫韩漫国漫免费看，下拉式滚动阅读，漫画免费追更，尽在酷漫屋
        </p>

        {/* Search Bar */}
        <div className="w-full max-w-lg mb-10">
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-foreground-500 text-base"></i>
            </span>
            <input
              type="text"
              placeholder="搜索你喜欢的漫画..."
              className="w-full pl-11 pr-5 py-3.5 text-sm bg-white/95 backdrop-blur-sm border border-white/20 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all duration-200 text-foreground-900 placeholder:text-foreground-400 shadow-lg"
            />
          </div>
        </div>

        {/* Top Manga Quick Links */}
        <div className="flex flex-wrap items-center justify-center gap-2">
          {topManga.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.slug}`}
              className="px-4 py-1.5 text-xs text-white/90 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full hover:bg-white/25 hover:text-white transition-all duration-200 whitespace-nowrap"
            >
              {manga.title}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}